import * as types from '../actions/types';

const initialState = {
  countryCode: 'MA',
  docType: 'legislation',
  referenceData: { data: null, loading: false, error: null },
  addFlow: {
    step: 'upload',
    taskId: null,
    progress: { step: '', percent: 0, message: '' },
    extractedMetadata: null,
    extractedHtml: null,
    publishedDocId: null,
    chunkCount: null,
    error: null,
  },
  editFlow: {
    search: { results: [], total: 0, loading: false, query: '', page: 1 },
    selected: { data: null, loading: false, error: null },
    publishing: { taskId: null, status: 'idle', progress: 0, message: '' },
    error: null,
  },
  abrogateFlow: {
    search: { results: [], total: 0, loading: false, query: '', page: 1 },
    selected: null,
    submitting: false,
    success: false,
    error: null,
  },
};

export default function dataUpdateReducer(state = initialState, action) {
  switch (action.type) {
    case types.DATA_UPDATE_SET_COUNTRY:
      return { ...state, countryCode: action.payload };
    case types.DATA_UPDATE_SET_DOC_TYPE:
      return { ...state, docType: action.payload };

    // Reference data
    case types.DATA_UPDATE_REFERENCE_DATA_REQUEST:
      return { ...state, referenceData: { ...state.referenceData, loading: true, error: null } };
    case types.DATA_UPDATE_REFERENCE_DATA_SUCCESS:
      return { ...state, referenceData: { data: action.payload, loading: false, error: null } };
    case types.DATA_UPDATE_REFERENCE_DATA_FAILURE:
      return { ...state, referenceData: { ...state.referenceData, loading: false, error: action.payload } };

    // Add flow
    case types.DATA_UPDATE_UPLOAD_START:
      return { ...state, addFlow: { ...initialState.addFlow, step: 'processing', taskId: action.payload } };
    case types.DATA_UPDATE_UPLOAD_PROGRESS:
      return { ...state, addFlow: { ...state.addFlow, progress: action.payload } };
    case types.DATA_UPDATE_REVIEW_READY:
      return {
        ...state,
        addFlow: {
          ...state.addFlow,
          step: 'review',
          extractedMetadata: action.payload.metadata,
          extractedHtml: action.payload.html_content,
        },
      };
    case types.DATA_UPDATE_UPLOAD_ERROR:
      return { ...state, addFlow: { ...state.addFlow, step: 'upload', error: action.payload } };
    case types.DATA_UPDATE_PUBLISH_START:
      return { ...state, addFlow: { ...state.addFlow, step: 'publishing', taskId: action.payload } };
    case types.DATA_UPDATE_PUBLISH_PROGRESS:
      return { ...state, addFlow: { ...state.addFlow, progress: action.payload } };
    case types.DATA_UPDATE_PUBLISH_COMPLETE:
      return {
        ...state,
        addFlow: {
          ...state.addFlow,
          step: 'complete',
          publishedDocId: action.payload.document_id,
          chunkCount: action.payload.chunk_count,
        },
      };
    case types.DATA_UPDATE_PUBLISH_ERROR:
      return { ...state, addFlow: { ...state.addFlow, step: 'review', error: action.payload } };
    case types.DATA_UPDATE_RESET_ADD_FLOW:
      return { ...state, addFlow: initialState.addFlow };

    // Edit flow - search
    case types.DATA_UPDATE_SEARCH_REQUEST:
      return { ...state, editFlow: { ...state.editFlow, search: { ...state.editFlow.search, loading: true } } };
    case types.DATA_UPDATE_SEARCH_SUCCESS:
      return {
        ...state,
        editFlow: {
          ...state.editFlow,
          search: {
            results: action.payload.results,
            total: action.payload.total,
            loading: false,
            query: action.payload.query,
            page: action.payload.page,
          },
        },
      };
    case types.DATA_UPDATE_SEARCH_FAILURE:
      return { ...state, editFlow: { ...state.editFlow, search: { ...state.editFlow.search, loading: false }, error: action.payload } };

    // Edit flow - select document
    case types.DATA_UPDATE_SELECT_DOC_REQUEST:
      return { ...state, editFlow: { ...state.editFlow, selected: { data: null, loading: true, error: null } } };
    case types.DATA_UPDATE_SELECT_DOC_SUCCESS:
      return { ...state, editFlow: { ...state.editFlow, selected: { data: action.payload, loading: false, error: null } } };
    case types.DATA_UPDATE_SELECT_DOC_FAILURE:
      return { ...state, editFlow: { ...state.editFlow, selected: { data: null, loading: false, error: action.payload } } };
    case types.DATA_UPDATE_EDIT_SAVE_REQUEST:
      return { ...state, editFlow: { ...state.editFlow, publishing: { ...state.editFlow.publishing, status: 'saving' } } };
    case types.DATA_UPDATE_EDIT_SAVE_SUCCESS:
      return { ...state, editFlow: { ...state.editFlow, publishing: { ...state.editFlow.publishing, status: 'idle' }, error: null } };
    case types.DATA_UPDATE_EDIT_SAVE_FAILURE:
      return { ...state, editFlow: { ...state.editFlow, publishing: { ...state.editFlow.publishing, status: 'idle' }, error: action.payload } };
    case types.DATA_UPDATE_RESET_EDIT_FLOW:
      return { ...state, editFlow: initialState.editFlow };

    // Abrogate flow
    case types.DATA_UPDATE_ABROGATE_REQUEST:
      return { ...state, abrogateFlow: { ...state.abrogateFlow, submitting: true, error: null } };
    case types.DATA_UPDATE_ABROGATE_SUCCESS:
      return { ...state, abrogateFlow: { ...state.abrogateFlow, submitting: false, success: true } };
    case types.DATA_UPDATE_ABROGATE_FAILURE:
      return { ...state, abrogateFlow: { ...state.abrogateFlow, submitting: false, error: action.payload } };
    case types.DATA_UPDATE_RESET_ABROGATE_FLOW:
      return { ...state, abrogateFlow: initialState.abrogateFlow };

    default:
      return state;
  }
}
